import type { Language } from '@/contexts/LanguageContext';

type SeoCopy = { title: string };

const LOGIN: Record<Language, SeoCopy> = {
  it: { title: 'Accedi — HiroMatch' },
  en: { title: 'Sign in — HiroMatch' },
};

const SIGNUP: Record<Language, SeoCopy> = {
  it: { title: 'Registrati — HiroMatch' },
  en: { title: 'Sign up — HiroMatch' },
};

const ONBOARDING: Record<Language, SeoCopy> = {
  it: { title: 'Configura la tua azienda — HiroMatch' },
  en: { title: 'Set up your company — HiroMatch' },
};

const INVITATION: Record<Language, SeoCopy> = {
  it: { title: 'Invito al team — HiroMatch' },
  en: { title: 'Team invitation — HiroMatch' },
};

const NOT_FOUND: Record<Language, SeoCopy> = {
  it: { title: 'Pagina non trovata — HiroMatch' },
  en: { title: 'Page not found — HiroMatch' },
};

export function loginSeo(lang: Language) {
  return LOGIN[lang === 'it' ? 'it' : 'en'];
}

export function signupSeo(lang: Language) {
  return SIGNUP[lang === 'it' ? 'it' : 'en'];
}

export function onboardingSeo(lang: Language) {
  return ONBOARDING[lang === 'it' ? 'it' : 'en'];
}

export function invitationSeo(lang: Language) {
  return INVITATION[lang === 'it' ? 'it' : 'en'];
}

export function notFoundSeo(lang: Language) {
  return NOT_FOUND[lang === 'it' ? 'it' : 'en'];
}
